











































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";

@Component({
  components: { AlertBox }
})
export default class SearchableSelect extends Vue {
  @Prop({ required: true }) readonly searchResult!: Array<any>;
  @Prop({ default: null }) readonly value!: any;
  @Prop({ default: "Please enter key to search item" })
  readonly placeholder!: string;
  @Prop({ default: false }) readonly disabled!: boolean;

  private search = "";
  private searching = false;
  private isOpened = false;
  private isHovered = false;
  private pointerId = 0;

  private mounted(): void {
    let idx = this.searchResult.length ? 0 : -1;
    if (this.hasValue() && this.searchResult && this.searchResult.length) {
      this.searchResult.forEach((option, index) => {
        if (this.value.id === option.id) {
          idx = index;
        }
      });
    }
    this.pointerId = idx;
  }

  private closeContent(): void {
    this.isOpened = false;
    this.search = "";
    this.isHovered = false;
  }

  private openContent(): void {
    this.isOpened = true;
  }

  private toggleContent(): void {
    if (this.isOpened) {
      this.closeContent();
    } else {
      this.openContent();
    }
  }

  private onSelectItem(value: string): void {
    this.$emit("input", value);
    this.toggleContent();
  }

  private onHoverList(): void {
    this.isHovered = true;
  }

  private onLeaveList(): void {
    this.isHovered = false;
  }

  private hasValue(): boolean {
    return (
      this.value &&
      !!this.searchResult.find(option => option.id === this.value.id)
    );
  }

  private pointerForward(): void {
    this.pointerId = (this.pointerId + 1) % this.searchResult.length;
  }

  private pointerBackward(): void {
    this.pointerId =
      (this.pointerId - 1 + this.searchResult.length) %
      this.searchResult.length;
  }

  private addPointerElement(): void {
    this.onSelectItem(this.searchResult[this.pointerId]);
  }

  @Watch("isOpened")
  opened(newState: boolean): void {
    if (newState) {
      this.$nextTick(function() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$refs.search.focus();
      });
    }
  }

  @Watch("search")
  searchChanged(newState: string): void {
    this.searching = true;
    this.$emit("change", newState);
  }

  @Watch("searchResult")
  searchResultChanged(newState: Array<any>): void {
    this.searching = false;
    if (!this.value) return;
    let idx = newState.length ? 0 : -1;
    if (this.hasValue()) {
      newState.forEach((option, index) => {
        if (this.value.id === option.id) {
          idx = index;
        }
      });
    }
    this.pointerId = idx;
  }
}
